import { Check, Star } from "lucide-react";
import { PLANS } from "@/data/content";
import { Reveal } from "./Reveal";

export default function Pricing({ onChoose }) {
  return (
    <section id="tarifs" className="py-24 md:py-32 px-6 md:px-10 bg-cream" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl mx-auto text-center">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Nos formules</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
              Des abonnements à votre image
            </h2>
            <p className="mt-5 text-forest/65">Choisissez la formule qui vous correspond. Sans engagement, ajustable à tout moment.</p>
          </div>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-3 gap-7 lg:gap-6 items-center">
          {PLANS.map((plan, i) => {
            const featured = plan.featured;
            return (
              <Reveal key={plan.name} delay={i * 0.1}>
                <div
                  className={`relative rounded-[2rem] p-8 md:p-9 transition-all duration-500 ${
                    featured
                      ? "bg-forest text-cream border border-gold/30 shadow-2xl lg:scale-[1.05] lg:-my-2"
                      : "bg-white text-forest border border-forest/8 shadow-sm hover:-translate-y-1 hover:shadow-xl"
                  }`}
                  data-testid={`pricing-card-${i}`}
                >
                  {plan.badge && (
                    <span className={`absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${featured ? "bg-gold text-white" : "bg-forest text-cream"}`}>
                      {plan.badge}
                    </span>
                  )}
                  <h3 className={`font-cormorant text-2xl md:text-3xl font-medium ${featured ? "text-cream" : "text-forest"}`}>{plan.name}</h3>
                  <ul className="mt-7 space-y-3.5">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-3 text-sm">
                        <span className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${featured ? "bg-gold/25" : "bg-sage/12"}`}>
                          <Check className={`w-3 h-3 ${featured ? "text-gold" : "text-sage"}`} strokeWidth={2.5} />
                        </span>
                        <span className={featured ? "text-cream/85" : "text-forest/80"}>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() => onChoose(plan.name)}
                    className={`mt-9 w-full py-3.5 rounded-full font-medium transition-all active:scale-[0.98] ${
                      featured
                        ? "bg-gold text-white hover:bg-golddark"
                        : "bg-forest text-cream hover:bg-forestdark"
                    }`}
                    data-testid={`pricing-choose-${i}`}
                  >
                    Choisir cette formule
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 flex items-center justify-center gap-2 text-sm text-forest/50">
            <Star className="w-4 h-4 text-gold fill-gold" />
            Premier échange toujours gratuit et sans engagement
          </div>
        </Reveal>
      </div>
    </section>
  );
}
